export { default } from './ContestsService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/contests/services/ContestsService/index.js